"use strict";
exports.__esModule = true;
var clients_1 = require("../clients");
var JoinType;
(function (JoinType) {
    JoinType[JoinType["CLEANER"] = 0] = "CLEANER";
    JoinType[JoinType["HOSTER"] = 1] = "HOSTER";
    JoinType[JoinType["CLUB"] = 2] = "CLUB";
})(JoinType = exports.JoinType || (exports.JoinType = {}));
var WebsiteAPI = /** @class */ (function () {
    function WebsiteAPI(debug, config) {
        this.gatewayClient = new clients_1.GatewayClient(debug, config);
        this.xbedGatewayClient = new clients_1.XbedGatewayClient(debug, config);
    }
    /**
     * 查询省份列表
     */
    WebsiteAPI.prototype.getProvinces = function () {
        return this.gatewayClient.queryProvinceList();
    };
    /**
     * 查询城市列表
     * @param provinceName 省份中文名 e.g. 广东省
     */
    WebsiteAPI.prototype.getCities = function (provinceName) {
        return this.gatewayClient.queryCityList(provinceName);
    };
    /**
     * 查询区域列表
     * @param provinceName 省份中文名 e.g. 广东省
     * @param cityName 城市中文名 e.g. 广州市
     */
    WebsiteAPI.prototype.getArea = function (provinceName, citiyName) {
        return this.gatewayClient.queryCountyList(provinceName, citiyName);
    };
    /**
     * 丽家会加盟/业主加盟/星创俱乐部加盟
     * @param type 业务类型，LJHJM
     * @param province 省份
     * @param city 城市
     * @param district 区域
     * @param address 地址
     * @param ltype
     * @param mobile 手机号码
     * @param name 姓名
     * @param cardId 身份证
     * @param remark 备注
     * @param sex	性别 0男 5女
     * @param source 了解渠道，0家人/朋友 5线下宣传/活动 10网络 15其他
     */
    WebsiteAPI.prototype.joinUs = function (joinData) {
        switch (joinData.type) {
            case JoinType.CLEANER:
                return this.gatewayClient.joinIn(joinData.province, joinData.city, joinData.district, joinData.address, 'LJHJM', joinData.mobile, joinData.name, joinData.cardId, joinData.remark, joinData.sex, joinData.source);
            case JoinType.CLUB:
                return this.gatewayClient.lender(joinData.province, joinData.city, joinData.district, joinData.address, 'XCJLB', joinData.mobile, joinData.name, joinData.remark, joinData.sex, joinData.source);
            case JoinType.HOSTER:
                return this.gatewayClient.lender(joinData.province, joinData.city, joinData.district, joinData.address, 'JOBLU', joinData.mobile, joinData.name, joinData.remark, joinData.sex, joinData.source);
        }
    };
    /**
     * 分页查询文章列表
     * @param column 文章栏目(1 => 集团动态，2 => 媒体报道，3 => 培训资料,null => 当前终端全部)
     * @param page
     * @param pageSize
     * @param terminal 终端位置(1Xbed官网，2丽家会，3其他)
     * @param token
     */
    WebsiteAPI.prototype.queryArticleList = function (column, page, pageSize, terminal, type) {
        return this.gatewayClient.queryArticleList({
            column: column,
            page: page,
            pageSize: pageSize,
            terminal: terminal,
            type: type,
            title: ''
        }, '' // 没有token
        );
    };
    /**
     * 文章详情
     * @param articleId 文章id
     */
    WebsiteAPI.prototype.getArticleDetails = function (articleId) {
        return this.gatewayClient.articleDetails(articleId);
    };
    /**
     * 共享入住人——获取图片验证码
     */
    WebsiteAPI.prototype.getShareOrderImageCode = function () {
        return this.xbedGatewayClient.imageVerifyCode();
    };
    /**
     * 共享入住人——获取短信验证码
     * @param code 图片验证码
     * @param isText 是否短信验证码
     * @param phone 手机号码
     * @param verifyCode redis的key
     */
    WebsiteAPI.prototype.getShareOrderMessageCode = function (code, isText, phone, verifyCode) {
        return this.xbedGatewayClient.messageVerifyCode(code, isText, phone, verifyCode);
    };
    /**
     * 共享入住人——获取共享订单信息
     * @param shareUUID
     */
    WebsiteAPI.prototype.getShareOrderInfo = function (shareUUID) {
        return this.xbedGatewayClient.shareInfo(shareUUID);
    };
    /**
     * 共享入住人——共享订单添加入住人
     * @param operator 分享人的电话号码
     * @param checkinId 入住单号
     * @param imageVerifyCode 图片验证码
     * @param messageVerifyCode 短信验证码
     * @param phone 手机号码
     * @param shareKey 共享的信息的UUID
     * @param verifyCode redis的key
     */
    WebsiteAPI.prototype.addShareOrderCheckiner = function (operator, checkinId, imageVerifyCode, messageVerifyCode, phone, shareKey, verifyCode) {
        return this.xbedGatewayClient.shareCheckin(operator, checkinId, imageVerifyCode, messageVerifyCode, phone, shareKey, verifyCode);
    };
    /**
     * 检查手机号码是否注册
     * @param phone 手机号码
     */
    WebsiteAPI.prototype.checkRegisterForLanding = function (phone) {
        return this.gatewayClient.checkRegisterForLanding(phone);
    };
    /**
     * 注册
     * @param phone 手机号码
     * @param source 注册渠道来源 0微信公众号 1去呼呼 2IOS 3Android 4OMS 5携程 6业主会 7美团 8XBED 10办理入住时系统注册 11活动注册 12预订时系统注册 14OTA 15wap 16www 17长租 18微信落地页
     */
    WebsiteAPI.prototype.registerForLanding = function (phone, source) {
        return this.gatewayClient.registerForLanding(phone, source);
    };
    /**
     * 查询房间详情信息V4
     * @param roomId 房间ID
     */
    WebsiteAPI.prototype.getRoomDetail = function (params) {
        return this.xbedGatewayClient.getRoomDetail(params);
    };
    /**
     * 七鱼客服系统后台 用户订单
     * @param phone  用户手机号
     * @param page  页码
     * @param size  每页显示的数量
     */
    WebsiteAPI.prototype.getQiyuOrderList = function (phone, page, size) {
        return this.xbedGatewayClient.getQiyuOrderList(phone, page, size);
    };
    return WebsiteAPI;
}());
exports.WebsiteAPI = WebsiteAPI;
//# sourceMappingURL=data:application/json;base64,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


//////////////////
// WEBPACK FOOTER
// ./node_modules/xbed-api/lib/apis/website-api.js
// module id = 225
// module chunks = 44